import { useEffect, useMemo, useSyncExternalStore } from 'react'
import { createSharedTimeframeStore, SHARED_TIMEFRAME_SCOPE } from '../lib/chart/sharedTimeframeProfiles.js'
import { sharedTimeframeTransport } from '../lib/chart/sharedTimeframeTransport.js'
const stores=new Map()
const empty={status:'disabled',profiles:{},candidates:{},errors:{},drafts:{},saving:{}}
const disabled={getSnapshot:()=>empty,subscribe:()=>()=>{},edit:async()=>false}
export function useSharedTimeframeProfiles(userId) {
  const entry=useMemo(()=>{
    if(!userId)return null
    if(!stores.has(userId)) {
      const key=`erevis-pending-timeframe-edits-v1:${SHARED_TIMEFRAME_SCOPE}:${userId}`
      const recovery={
        load:()=>JSON.parse(localStorage.getItem(key) || 'null'),
        save:value=>Object.values(value.drafts).some(Boolean) ? localStorage.setItem(key,JSON.stringify(value)) : localStorage.removeItem(key),
      }
      stores.set(userId,{store:createSharedTimeframeStore(sharedTimeframeTransport(userId),recovery),users:0})
    }
    return stores.get(userId)
  },[userId])
  useEffect(()=>{
    if(!entry)return
    entry.users++
    if(entry.users===1) {
      entry.store.refresh()
      entry.refresh=()=>entry.store.refresh()
      entry.timer=setInterval(()=>{if(document.visibilityState!=='hidden')entry.store.refresh()},3000)
      window.addEventListener('focus',entry.refresh)
      window.addEventListener('online',entry.refresh)
      document.addEventListener('visibilitychange',entry.refresh)
    }
    return()=>{
      entry.users--
      if(entry.users===0){
        clearInterval(entry.timer)
        window.removeEventListener('focus',entry.refresh)
        window.removeEventListener('online',entry.refresh)
        document.removeEventListener('visibilitychange',entry.refresh)
        // Retain failed drafts on same-account page navigation. Never return a
        // different owner's entry; all network operations remain owner filtered.
      }
    }
  },[entry])
  const store=entry?.store || disabled
  const snapshot=useSyncExternalStore(store.subscribe,store.getSnapshot,store.getSnapshot)
  return { ...snapshot,store }
}
